import React from "react"
import { useTranslation } from "react-i18next"

import CustomDropdown from "../Common/Form/Dropdown"

const ServiceCenterFilter = (props) => {
    const {
        serviceCenterListData,
        serviceCenterHandler,
        dayRangeFilterFeature,
        dayRangeListData,
        dayRangeHandler,
        defaultValue,
        disabled = false 
    } = props
    const { t } = useTranslation()
    const onHandleChange = (e, name) => {
        serviceCenterHandler(e, name)
    }
    const onHandleRangeChange = (e, name) => {
        dayRangeHandler(e, name)
    }
    
    return (
        <>
            { dayRangeFilterFeature && (
                <CustomDropdown
                    options={ dayRangeListData }
                    placeholder={ t("orderManagement.view") }
                    defaultValue={ dayRangeListData[1]?.value }
                    name="dayRangeFeature"
                    changeHandler={ (e, name) => { onHandleRangeChange(e, name) } }
                    errorData={ {} }
                    isMulti={ false }
                    isRequired={ false }
                />)
            }
            { serviceCenterListData?.length > 0 && (
                
                <CustomDropdown
                    options={ serviceCenterListData }
                    placeholder={ t("orderManagement.serviceCenterName") }
                    defaultValue={ defaultValue }
                    name="serviceCenterFeature"
                    changeHandler={ (e, name) => { onHandleChange(e, name) } }
                    errorData={ {} }
                    isMulti={ false }
                    isRequired={ false }
                    disabled={ disabled }
                    isUnselectEnabled={ true }
                />)
            }
        </>
    )
}

export default ServiceCenterFilter
